import React from 'react';
import { Form } from 'react-bootstrap';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import _ from 'lodash';
import i18next, { t } from 'i18next';
import is from 'lang/textEditorIS';

const ReactHtmlTextEditor = ({
    field: { ...fields },
    form: { touched, errors, setFieldTouched, setFieldValue },
    ...props
}) => {
    const { id, ...rest } = props;
    const error = errors[fields.name];
    const touch = touched[fields.name];
    const editorStyle = {
        border: '1px solid #C0C0C0',
        padding: '5px',
        borderRadius: '2px',
        height: '200px',
        width: '100%',
        overflow: 'auto',
    };

    const onEditorStateChange = (editorState) => {
        changeValue(editorState);
    };

    const changeValue = (editorState) => {
        setFieldTouched(fields.name, true);
        setFieldValue(fields.name, editorState);
    };
    const uploadImageCallBack = async (file) => {
        if (_.isObject(file)) {
            const url = await props.handleImageUpload(file);
            return new Promise((resolve) => {
                resolve({
                    data: { link: url || '' },
                });
            });
        }
    };

    return (
        <Form.Group controlId={id} className="form-group">
            {props.label && <Form.Label className={'label-color'}>{props.label}</Form.Label>}
            <Form.Control
                {...rest}
                editorState={fields.value}
                onEditorStateChange={(editorState) => onEditorStateChange(editorState)}
                as={Editor}
                editorStyle={editorStyle}
                toolbar={{
                    image: {
                        uploadCallback: uploadImageCallBack,
                        previewImage: true,
                        alt: { present: true, mandatory: false },
                        inputAccept: 'image/jpeg,image/jpg,image/png,image/svg',
                        title: t('editor.image'),
                    },
                }}
                editorClassName={
                    Boolean(touched[fields.name] && errors[fields.name]) ? 'form-control is-invalid' : 'form-control'
                }
                isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
                localization={{
                    locale: i18next.language,
                    translations: i18next.language === 'is' ? is : undefined,
                }}
            />
            {touch && error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
        </Form.Group>
    );
};
export default ReactHtmlTextEditor;
